var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLumieredujour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lumi\\xE8re_du_jour",
    "data-name": "lumi\\xE8re du jour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,18.87A14.14,14.14,0,0,0,18.87,33a13.87,13.87,0,0,0,.3,2.88,1,1,0,0,0,1.92-.4,12.14,12.14,0,1,1,2.54,5.28A1,1,0,1,0,22.13,42,14.11,14.11,0,1,0,33,18.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,7.88a1,1,0,0,0-1,1v6.39a1,1,0,0,0,2,0V8.86A1,1,0,0,0,33,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,49.75a1,1,0,0,0-1,1v6.39a1,1,0,1,0,2,0V50.73A1,1,0,0,0,33,49.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.12,32H50.73a1,1,0,0,0,0,2h6.39a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.25,32H8.86a1,1,0,0,0,0,2h6.39a1,1,0,1,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.74,15.24a1,1,0,0,0-1.38,0l-4.52,4.51a1,1,0,0,0,0,1.39,1,1,0,0,0,.69.29,1,1,0,0,0,.7-.29l4.51-4.52A1,1,0,0,0,50.74,15.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.14,44.84a1,1,0,0,0-1.39,0l-4.51,4.52a1,1,0,0,0,0,1.38,1,1,0,0,0,1.38,0l4.52-4.51A1,1,0,0,0,21.14,44.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.74,49.36l-4.51-4.52a1,1,0,1,0-1.39,1.39l4.52,4.51a1,1,0,0,0,1.38,0A1,1,0,0,0,50.74,49.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.14,19.75l-4.52-4.51a1,1,0,1,0-1.38,1.38l4.51,4.52a1,1,0,0,0,.7.29,1,1,0,0,0,.69-.29A1,1,0,0,0,21.14,19.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.92,38.14a1,1,0,1,0,.29.69A1,1,0,0,0,21.92,38.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.55,32.32a9.54,9.54,0,0,0-2.47-5.78,1,1,0,0,0-1.45,1.32,7.66,7.66,0,0,1,2,4.6,1,1,0,0,0,1,.91h.07A1,1,0,0,0,42.55,32.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.29,35.42a1,1,0,0,0-1.68.69,1,1,0,0,0,.29.7,1,1,0,0,0,1.39,0,1,1,0,0,0,.29-.7A1,1,0,0,0,42.29,35.42Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumieredujour);
export default __webpack_public_path__ + "static/media/lumieredujour.2823183a3f9269b0ee27676fa1f14423.svg";
export { ForwardRef as ReactComponent };